// Vendors
import { FooterComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import {
  BACKGROUND_MODAL_FOOTER_DECLINE_BUTTON_PROPS,
  BACKGROUND_MODAL_FOOTER_PROPS,
  BACKGROUND_MODAL_FOOTER_STAY_BUTTON_PROPS,
} from './constants/background-footer.constants';
// Hooks
import { useBackgroundFooterHook } from './hooks/background-footer.hook';
// Styles
import { BackgroundFooterComponentStyled } from './background-footer.component.styled';
// Translations
import { DECLINE_ONBOARDING, STAY_ONBOARDING } from './translations/background-footer.translations';
// Types
import { BackgroundHookType } from '../../hooks/types/background.hook.type';

const BackgroundFooterComponent = (
  props: Pick<BackgroundHookType, 'setShowBackgroundModal'>
): React.ReactNode => {
  const { handleLogCallbackUrlCallEvent, handleManageCustomerAgreementButtonClick } =
    useBackgroundFooterHook(props);

  return (
    <BackgroundFooterComponentStyled>
      <FooterComponent
        {...BACKGROUND_MODAL_FOOTER_PROPS}
        mainButtonConfiguration={{
          ...BACKGROUND_MODAL_FOOTER_STAY_BUTTON_PROPS,
          children: <FormattedMessage id={STAY_ONBOARDING} />,
          onClick: handleManageCustomerAgreementButtonClick,
        }}
        secondaryButtonConfiguration={{
          ...BACKGROUND_MODAL_FOOTER_DECLINE_BUTTON_PROPS,
          children: <FormattedMessage id={DECLINE_ONBOARDING} />,
          onClick: handleLogCallbackUrlCallEvent,
        }}
      />
    </BackgroundFooterComponentStyled>
  );
};

export { BackgroundFooterComponent };
